var _path, _path2, _path3, _rect, _g, _g2, _rect2, _g3, _g4, _rect3, _g5, _g6, _rect4, _g7, _g8, _path4, _path5, _path6, _rect5, _g9, _g0, _rect6, _g1, _g10, _rect7, _g11, _g12, _rect8, _g13, _g14, _g15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGinasteeAttributes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1492,
    height: 230,
    viewBox: "0 0 1492 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2243",
    clipPath: "url(#clip0_7089_144)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 198",
    d: "M775 73.5H970.6C989.423 73.5 1007.8 67.7884 1023.31 57.12L1046.19 41.38C1061.7 30.7116 1080.08 25 1098.9 25L1491 25",
    stroke: "#9A9A9A",
    strokeDasharray: "5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 199",
    d: "M775 157H970.6C989.423 157 1007.8 162.712 1023.31 173.38L1046.19 189.12C1061.7 199.788 1080.08 205.5 1098.9 205.5H1491.5",
    stroke: "#9A9A9A",
    strokeDasharray: "5 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 200",
    d: "M780 117H1084",
    stroke: "#9A9A9A",
    strokeDasharray: "5 5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-7"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1151,
    width: 49,
    height: 49,
    rx: 17,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "video-play 1",
    clipPath: "url(#clip1_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1161,
    y: 10,
    width: 29,
    height: 29
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1190 10H1161V39H1190V10Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1178.8 12.4219H1172.2V17.6902H1178.8V12.4219Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1180.61 12.4219V17.6902H1187.43C1186.81 14.3673 1184.36 12.434 1180.61 12.4219Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1163.42 19.5V29.5655C1163.42 33.9638 1166.04 36.5859 1170.44 36.5859H1180.56C1184.96 36.5859 1187.58 33.9638 1187.58 29.5655V19.5H1163.42ZM1178.45 29.5534L1175.94 31.0034C1175.4 31.3055 1174.89 31.4626 1174.4 31.4626C1174.04 31.4626 1173.71 31.378 1173.41 31.2088C1172.71 30.8101 1172.32 29.9884 1172.32 28.9251V26.0251C1172.32 24.9617 1172.71 24.1401 1173.41 23.7413C1174.11 23.3305 1175.01 23.403 1175.94 23.9467L1178.45 25.3967C1179.38 25.9284 1179.89 26.6776 1179.89 27.4871C1179.89 28.2967 1179.37 29.0096 1178.45 29.5534Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1170.39 12.4219C1166.64 12.434 1164.19 14.3673 1163.57 17.6902H1170.39V12.4219Z",
    fill: "#404040"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-5"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 926,
    y: 92,
    width: 52,
    height: 52,
    rx: 17,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "medal-star 1",
    clipPath: "url(#clip2_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 936,
    y: 102,
    width: 32,
    height: 32
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M968 102H936V134H968V102Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M964.334 126.626L962.134 127.146C961.64 127.266 961.254 127.639 961.147 128.132L960.68 130.092C960.427 131.159 959.067 131.492 958.36 130.652L954.374 126.066C954.054 125.692 954.227 125.106 954.707 124.986C957.067 124.412 959.187 123.092 960.747 121.212C961 120.906 961.454 120.866 961.734 121.146L964.694 124.106C965.707 125.119 965.347 126.386 964.334 126.626Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M939.6 126.626L941.8 127.146C942.294 127.266 942.68 127.639 942.787 128.132L943.254 130.092C943.507 131.159 944.867 131.492 945.574 130.652L949.56 126.066C949.88 125.692 949.707 125.106 949.227 124.986C946.867 124.412 944.747 123.092 943.187 121.212C942.934 120.906 942.48 120.866 942.2 121.146L939.24 124.106C938.227 125.119 938.587 126.386 939.6 126.626Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M951.999 104.664C946.839 104.664 942.666 108.837 942.666 113.997C942.666 115.931 943.239 117.704 944.226 119.184C945.666 121.317 947.946 122.824 950.599 123.211C951.053 123.291 951.519 123.331 951.999 123.331C952.479 123.331 952.946 123.291 953.399 123.211C956.053 122.824 958.333 121.317 959.773 119.184C960.759 117.704 961.333 115.931 961.333 113.997C961.333 108.837 957.159 104.664 951.999 104.664ZM956.079 113.704L954.973 114.811C954.786 114.997 954.679 115.357 954.746 115.624L955.066 116.997C955.319 118.077 954.746 118.504 953.786 117.931L952.453 117.144C952.213 116.997 951.813 116.997 951.573 117.144L950.239 117.931C949.279 118.491 948.706 118.077 948.959 116.997L949.279 115.624C949.333 115.371 949.239 114.997 949.053 114.811L947.919 113.704C947.266 113.051 947.479 112.397 948.386 112.251L949.813 112.011C950.053 111.971 950.333 111.757 950.439 111.544L951.226 109.971C951.653 109.117 952.346 109.117 952.773 109.971L953.559 111.544C953.666 111.757 953.946 111.971 954.199 112.011L955.626 112.251C956.519 112.397 956.733 113.051 956.079 113.704Z",
    fill: "#404040"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-6"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1081,
    y: 92,
    width: 49,
    height: 49,
    rx: 17,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "document 1",
    clipPath: "url(#clip3_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1091,
    y: 102,
    width: 29,
    height: 29
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M1120 102H1091V131H1120V102Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M1115.77 114.314H1112.28C1109.42 114.314 1107.08 111.982 1107.08 109.118V105.626C1107.08 104.962 1106.54 104.418 1105.88 104.418H1100.75C1097.03 104.418 1094.02 106.835 1094.02 111.148V121.854C1094.02 126.168 1097.03 128.585 1100.75 128.585H1110.25C1113.97 128.585 1116.98 126.168 1116.98 121.854V115.523C1116.98 114.858 1116.44 114.314 1115.77 114.314Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M1110.09 104.673C1109.6 104.178 1108.74 104.516 1108.74 105.205V109.422C1108.74 111.186 1110.24 112.648 1112.06 112.648C1113.21 112.66 1114.8 112.66 1116.17 112.66C1116.86 112.66 1117.22 111.85 1116.74 111.367C1115 109.615 1111.88 106.461 1110.09 104.673Z",
    fill: "#404040"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-8"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1151,
    y: 181,
    width: 49,
    height: 49,
    rx: 17,
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "message-text-1 1",
    clipPath: "url(#clip4_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1161,
    y: 191,
    width: 29,
    height: 29
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M1190 191H1161V220H1190V191Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M1181.54 193.422H1169.46C1166.12 193.422 1163.42 196.116 1163.42 199.439V206.665V207.874C1163.42 211.196 1166.12 213.891 1169.46 213.891H1171.27C1171.6 213.891 1172.03 214.109 1172.24 214.374L1174.05 216.779C1174.85 217.842 1176.15 217.842 1176.95 216.779L1178.76 214.374C1178.99 214.072 1179.35 213.891 1179.73 213.891H1181.54C1184.88 213.891 1187.58 211.196 1187.58 207.874V199.439C1187.58 196.116 1184.88 193.422 1181.54 193.422ZM1176.71 207.62H1169.46C1168.96 207.62 1168.55 207.209 1168.55 206.714C1168.55 206.218 1168.96 205.807 1169.46 205.807H1176.71C1177.2 205.807 1177.61 206.218 1177.61 206.714C1177.61 207.209 1177.2 207.62 1176.71 207.62ZM1181.54 201.578H1169.46C1168.96 201.578 1168.55 201.167 1168.55 200.672C1168.55 200.176 1168.96 199.766 1169.46 199.766H1181.54C1182.04 199.766 1182.45 200.176 1182.45 200.672C1182.45 201.167 1182.04 201.578 1181.54 201.578Z",
    fill: "#404040"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 201",
    d: "M685 73.5H489.4C470.577 73.5 452.198 67.7884 436.69 57.12L413.81 41.38C398.302 30.7116 379.923 25 361.1 25H1.5",
    stroke: "#9A9A9A",
    strokeDasharray: "5 5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 202",
    d: "M685 157H489.4C470.577 157 452.198 162.712 436.69 173.38L413.81 189.12C398.302 199.788 379.923 205.5 361.1 205.5H0.5",
    stroke: "#9A9A9A",
    strokeDasharray: "5 5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 203",
    d: "M685 117H381",
    stroke: "#9A9A9A",
    strokeDasharray: "5 5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-01"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 17,
    transform: "matrix(-1 0 0 1 335 0)",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chart-3 1",
    clipPath: "url(#clip5_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 10,
    width: 24,
    height: 24
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M325 10H301V34H325V10Z",
    fill: "white"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M323 32H303C302.59 32 302.25 31.66 302.25 31.25C302.25 30.84 302.59 30.5 303 30.5H323C323.41 30.5 323.75 30.84 323.75 31.25C323.75 31.66 323.41 32 323 32Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M310.75 14V32H315.25V14C315.25 12.9 314.8 12 313.45 12H312.55C311.2 12 310.75 12.9 310.75 14Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M304 20V32H308V20C308 18.9 307.6 18 306.4 18H305.6C304.4 18 304 18.9 304 20Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M318 25V32H322V25C322 23.9 321.6 23 320.4 23H319.6C318.4 23 318 23.9 318 25Z",
    fill: "#404040"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-02"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 17,
    transform: "matrix(-1 0 0 1 557 92)",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "people 1",
    clipPath: "url(#clip6_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 523,
    y: 102,
    width: 24,
    height: 24
  }, _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_3111_32729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M547 102H523V126H547V102Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M540.531 109.77C540.461 109.76 540.391 109.76 540.321 109.77C538.771 109.72 537.541 108.45 537.541 106.89C537.541 105.3 538.831 104 540.431 104C542.021 104 543.321 105.29 543.321 106.89C543.311 108.45 542.081 109.72 540.531 109.77Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M543.792 116.7C542.672 117.45 541.102 117.73 539.652 117.54C540.032 116.72 540.232 115.81 540.242 114.85C540.242 113.85 540.022 112.9 539.602 112.07C541.082 111.87 542.652 112.15 543.782 112.9C545.362 113.94 545.362 115.65 543.792 116.7Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M529.44 109.77C529.51 109.76 529.58 109.76 529.65 109.77C531.2 109.72 532.43 108.45 532.43 106.89C532.43 105.29 531.14 104 529.54 104C527.95 104 526.66 105.29 526.66 106.89C526.66 108.45 527.89 109.72 529.44 109.77Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M529.551 114.851C529.551 115.821 529.761 116.741 530.141 117.571C528.731 117.721 527.261 117.421 526.181 116.711C524.601 115.661 524.601 113.951 526.181 112.901C527.251 112.181 528.761 111.891 530.181 112.051C529.771 112.891 529.551 113.841 529.551 114.851Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M535.121 117.87C535.041 117.86 534.951 117.86 534.861 117.87C533.021 117.81 531.551 116.3 531.551 114.44C531.561 112.54 533.091 111 535.001 111C536.901 111 538.441 112.54 538.441 114.44C538.431 116.3 536.971 117.81 535.121 117.87Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M531.871 119.941C530.361 120.951 530.361 122.611 531.871 123.611C533.591 124.761 536.411 124.761 538.131 123.611C539.641 122.601 539.641 120.941 538.131 119.941C536.421 118.791 533.601 118.791 531.871 119.941Z",
    fill: "#404040"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-03"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 17,
    transform: "matrix(-1 0 0 1 410 92)",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "document 1_2",
    clipPath: "url(#clip7_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 371,
    y: 102,
    width: 29,
    height: 29
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8497_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M371 102H400V131H371V102Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M375.229 114.314H378.721C381.584 114.314 383.916 111.982 383.916 109.118V105.626C383.916 104.962 384.46 104.418 385.125 104.418H390.248C393.97 104.418 396.979 106.835 396.979 111.148V121.854C396.979 126.168 393.97 128.585 390.248 128.585H380.751C377.029 128.585 374.02 126.168 374.02 121.854V115.523C374.02 114.858 374.564 114.314 375.229 114.314Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M380.908 104.673C381.404 104.178 382.262 104.516 382.262 105.205V109.422C382.262 111.186 380.763 112.648 378.939 112.648C377.791 112.66 376.196 112.66 374.83 112.66C374.142 112.66 373.779 111.85 374.263 111.367C376.003 109.615 379.12 106.461 380.908 104.673Z",
    fill: "#404040"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "draw-badge-04"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 17,
    transform: "matrix(-1 0 0 1 340 181)",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("g", {
    id: "message-text-1 1_2",
    clipPath: "url(#clip8_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_7089_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 301,
    y: 191,
    width: 29,
    height: 29
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "clip0_4418_8202_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M301 191H330V220H301V191Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_7089_144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M309.459 193.422H321.542C324.877 193.422 327.584 196.116 327.584 199.439V206.665V207.874C327.584 211.196 324.877 213.891 321.542 213.891H319.73C319.404 213.891 318.969 214.109 318.763 214.374L316.951 216.779C316.153 217.842 314.848 217.842 314.051 216.779L312.238 214.374C312.009 214.072 311.646 213.891 311.271 213.891H309.459C306.124 213.891 303.417 211.196 303.417 207.874V199.439C303.417 196.116 306.124 193.422 309.459 193.422ZM314.292 207.62H321.542C322.038 207.62 322.449 207.209 322.449 206.714C322.449 206.218 322.038 205.807 321.542 205.807H314.292C313.797 205.807 313.386 206.218 313.386 206.714C313.386 207.209 313.797 207.62 314.292 207.62ZM309.459 201.578H321.542C322.038 201.578 322.449 201.167 322.449 200.672C322.449 200.176 322.038 199.766 321.542 199.766H309.459C308.964 199.766 308.553 200.176 308.553 200.672C308.553 201.167 308.964 201.578 309.459 201.578Z",
    fill: "#404040"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2238"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2225"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 658,
    y: 31,
    width: 172,
    height: 172.796,
    rx: 86,
    fill: "#132B33"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2224"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 665.963,
    y: 38.9648,
    width: 156.074,
    height: 156.87,
    rx: 78.037,
    fill: "#132B33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.759,
    y: 39.7611,
    width: 154.481,
    height: 155.278,
    rx: 77.2407,
    stroke: "#D6F0F9",
    strokeOpacity: 0.22,
    strokeWidth: 1.59259
  }), /*#__PURE__*/React.createElement("g", {
    id: "M_BLACK_LOGO_FULL (1) 4",
    filter: "url(#filter0_d_7089_144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M691.089 107.523H702.339L695.405 111.451H691.089C689.61 111.451 687.518 111.697 686.39 112.365C685.263 113.014 684.385 113.913 683.757 115.063C683.147 116.213 682.842 117.503 682.842 118.931C682.842 120.433 683.323 121.63 684.284 122.52C685.263 123.392 686.658 123.828 688.469 123.828C689.615 123.828 690.687 123.596 691.684 123.132L692.821 117.289H696.923L695.315 125.302C694.336 126.063 693.2 126.647 691.906 127.055C690.613 127.463 689.273 127.667 687.887 127.667C685.947 127.667 684.256 127.315 682.815 126.61C681.373 125.905 680.256 124.913 679.461 123.633C678.685 122.353 678.297 120.878 678.297 119.209C678.297 117.002 678.805 115.008 679.821 113.227C680.838 111.446 682.27 110.055 684.118 109.054C685.965 108.034 688.686 107.523 691.089 107.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M701.227 109.693L706.325 106.621L702.448 127.325H697.926L701.227 109.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M725.544 107.449L721.662 127.676H717.974L710.736 115.02L708.296 127.676H703.859L707.742 107.449H711.457L718.695 120.134L721.107 107.449H725.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M739.065 123.342H730.026L727.503 127.676H722.707L735.266 107.449H739.702L744.471 127.676H739.979L739.065 123.342ZM738.316 119.787L736.68 111.986L732.106 119.787H738.316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M746.282 127.01C747.688 127.418 749.159 127.623 750.694 127.623C752.489 127.623 754.062 127.353 755.412 126.815C756.763 126.257 757.808 125.486 758.548 124.502C759.288 123.499 759.658 122.329 759.658 120.991C759.658 119.914 759.371 119.05 758.798 118.4C758.243 117.731 757.567 117.23 756.772 116.895C755.976 116.542 754.959 116.198 753.719 115.864C752.85 115.623 752.174 115.418 751.693 115.251C751.213 115.065 750.815 114.833 750.5 114.554C750.186 114.257 750.028 113.895 750.028 113.468C750.028 112.762 750.398 112.186 751.138 111.74C751.879 111.294 752.887 111.072 754.163 111.072C755.144 111.072 756.087 111.202 756.994 111.462C757 111.463 757.006 111.465 757.012 111.466L757.758 107.805C756.702 107.568 755.587 107.449 754.413 107.449C752.637 107.449 751.074 107.719 749.723 108.257C748.391 108.796 747.355 109.567 746.615 110.57C745.893 111.573 745.533 112.734 745.533 114.053C745.533 115.186 745.819 116.096 746.393 116.784C746.985 117.471 747.679 117.991 748.474 118.344C749.27 118.678 750.297 119.031 751.555 119.403C752.813 119.756 753.729 120.09 754.302 120.406C754.876 120.703 755.162 121.14 755.162 121.716C755.162 122.422 754.802 122.979 754.08 123.387C753.358 123.796 752.378 124 751.138 124C749.973 124 748.835 123.824 747.725 123.471C746.673 123.136 745.72 122.668 744.867 122.067L746.061 126.944C746.134 126.966 746.207 126.988 746.282 127.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M758.654 111.263H764.861L761.73 127.676H766.22L769.379 111.263H775.558L777.162 111.248L774.011 127.676H789.032L789.78 123.919H779.194L780.08 119.238H789.114L789.808 115.598H780.801L781.632 111.206L794.923 111.248L791.772 127.676H806.793L807.542 123.919H796.955L797.841 119.238H806.876L807.569 115.598H798.561L799.393 111.206H809.563L816.497 107.449H795.652H759.402L758.654 111.263Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "brightness-effect"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bright-36",
    filter: "url(#filter1_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 672,
    cy: 157,
    rx: 29,
    ry: 1,
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-35",
    filter: "url(#filter2_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 668.5,
    cy: 160.5,
    rx: 10.5,
    ry: 0.5,
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-34",
    filter: "url(#filter3_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 676,
    cy: 157,
    rx: 17,
    ry: 1,
    fill: "#D1EEFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-33",
    filter: "url(#filter4_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 674,
    cy: 157,
    rx: 12,
    ry: 2,
    fill: "#F2FBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-32",
    filter: "url(#filter5_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 680,
    cy: 151.5,
    rx: 11,
    ry: 0.5,
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-31",
    filter: "url(#filter6_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 687,
    cy: 156,
    rx: 11,
    ry: 5,
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-30",
    filter: "url(#filter7_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 644,
    cy: 117,
    rx: 29,
    ry: 1,
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-29",
    filter: "url(#filter8_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 656.5,
    cy: 121.5,
    rx: 10.5,
    ry: 0.5,
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-28",
    filter: "url(#filter9_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 648,
    cy: 117,
    rx: 17,
    ry: 1,
    fill: "#D1EEFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-27",
    filter: "url(#filter10_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 646,
    cy: 117,
    rx: 12,
    ry: 2,
    fill: "#F2FBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-26",
    filter: "url(#filter11_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 652,
    cy: 111.5,
    rx: 11,
    ry: 0.5,
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-25",
    filter: "url(#filter12_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 659,
    cy: 116,
    rx: 11,
    ry: 5,
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-24",
    filter: "url(#filter13_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 1,
    rx: 29,
    ry: 1,
    transform: "matrix(-1 0 0 1 838 73)",
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-23",
    filter: "url(#filter14_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 0.5,
    rx: 10.5,
    ry: 0.5,
    transform: "matrix(-1 0 0 1 807 78)",
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-22",
    filter: "url(#filter15_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 1,
    rx: 17,
    ry: 1,
    transform: "matrix(-1 0 0 1 822 73)",
    fill: "#D1EEFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-21",
    filter: "url(#filter16_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 2,
    rx: 12,
    ry: 2,
    transform: "matrix(-1 0 0 1 819 72)",
    fill: "#F2FBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-20",
    filter: "url(#filter17_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 0.5,
    rx: 11,
    ry: 0.5,
    transform: "matrix(-1 0 0 1 812 68)",
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-19",
    filter: "url(#filter18_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 5,
    rx: 11,
    ry: 5,
    transform: "matrix(-1 0 0 1 805 68)",
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-18",
    filter: "url(#filter19_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 670,
    cy: 74,
    rx: 29,
    ry: 1,
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-17",
    filter: "url(#filter20_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 667.5,
    cy: 77.5,
    rx: 10.5,
    ry: 0.5,
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-16",
    filter: "url(#filter21_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 674,
    cy: 74,
    rx: 17,
    ry: 1,
    fill: "#D1EEFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-15",
    filter: "url(#filter22_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 672,
    cy: 74,
    rx: 12,
    ry: 2,
    fill: "#F2FBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-14",
    filter: "url(#filter23_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 678,
    cy: 68.5,
    rx: 11,
    ry: 0.5,
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-13",
    filter: "url(#filter24_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 685,
    cy: 73,
    rx: 11,
    ry: 5,
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-12",
    filter: "url(#filter25_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 1,
    rx: 29,
    ry: 1,
    transform: "matrix(-1 0 0 1 873 115)",
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-11",
    filter: "url(#filter26_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 0.5,
    rx: 10.5,
    ry: 0.5,
    transform: "matrix(-1 0 0 1 857 119)",
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-10",
    filter: "url(#filter27_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 1,
    rx: 17,
    ry: 1,
    transform: "matrix(-1 0 0 1 857 115)",
    fill: "#D1EEFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-09",
    filter: "url(#filter28_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 2,
    rx: 12,
    ry: 2,
    transform: "matrix(-1 0 0 1 854 114)",
    fill: "#F2FBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-08",
    filter: "url(#filter29_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 0.5,
    rx: 11,
    ry: 0.5,
    transform: "matrix(-1 0 0 1 847 110)",
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-07",
    filter: "url(#filter30_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 5,
    rx: 11,
    ry: 5,
    transform: "matrix(-1 0 0 1 840 110)",
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-06",
    filter: "url(#filter31_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 1,
    rx: 29,
    ry: 1,
    transform: "matrix(-1 0 0 1 860 156)",
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-05",
    filter: "url(#filter32_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 0.5,
    rx: 10.5,
    ry: 0.5,
    transform: "matrix(-1 0 0 1 844 160)",
    fill: "#8FDAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-04",
    filter: "url(#filter33_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 1,
    rx: 17,
    ry: 1,
    transform: "matrix(-1 0 0 1 844 156)",
    fill: "#D1EEFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-03",
    filter: "url(#filter34_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 2,
    rx: 12,
    ry: 2,
    transform: "matrix(-1 0 0 1 841 155)",
    fill: "#F2FBFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-02",
    filter: "url(#filter35_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 0.5,
    rx: 11,
    ry: 0.5,
    transform: "matrix(-1 0 0 1 834 151)",
    fill: "#C9EBFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bright-01",
    filter: "url(#filter36_f_7089_144)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 5,
    rx: 11,
    ry: 5,
    transform: "matrix(-1 0 0 1 827 151)",
    fill: "#C9EBFC"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7089_144",
    x: 634.723,
    y: 63.6211,
    width: 225.352,
    height: 107.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 21.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.269231 0 0 0 0 0.817308 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7089_144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7089_144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7089_144",
    x: 640,
    y: 153,
    width: 64,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7089_144",
    x: 657,
    y: 159,
    width: 23,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7089_144",
    x: 658,
    y: 155,
    width: 36,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7089_144",
    x: 661,
    y: 154,
    width: 26,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_7089_144",
    x: 668,
    y: 150,
    width: 24,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_7089_144",
    x: 663,
    y: 138,
    width: 48,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_7089_144",
    x: 612,
    y: 113,
    width: 64,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_7089_144",
    x: 645,
    y: 120,
    width: 23,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_7089_144",
    x: 630,
    y: 115,
    width: 36,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_7089_144",
    x: 633,
    y: 114,
    width: 26,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_7089_144",
    x: 640,
    y: 110,
    width: 24,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_7089_144",
    x: 635,
    y: 98,
    width: 48,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_7089_144",
    x: 777,
    y: 70,
    width: 64,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_7089_144",
    x: 785,
    y: 77,
    width: 23,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_7089_144",
    x: 787,
    y: 72,
    width: 36,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_7089_144",
    x: 794,
    y: 71,
    width: 26,
    height: 6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_7089_144",
    x: 789,
    y: 67,
    width: 24,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_7089_144",
    x: 770,
    y: 55,
    width: 48,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_7089_144",
    x: 638,
    y: 70,
    width: 64,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_7089_144",
    x: 656,
    y: 76,
    width: 23,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_7089_144",
    x: 656,
    y: 72,
    width: 36,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_7089_144",
    x: 656,
    y: 68,
    width: 32,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_7089_144",
    x: 666,
    y: 67,
    width: 24,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_7089_144",
    x: 661,
    y: 55,
    width: 48,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_7089_144",
    x: 812,
    y: 112,
    width: 64,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_7089_144",
    x: 835,
    y: 118,
    width: 23,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_7089_144",
    x: 822,
    y: 114,
    width: 36,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_7089_144",
    x: 826,
    y: 110,
    width: 32,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_7089_144",
    x: 824,
    y: 109,
    width: 24,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_7089_144",
    x: 805,
    y: 97,
    width: 48,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_7089_144",
    x: 799,
    y: 153,
    width: 64,
    height: 8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_7089_144",
    x: 822,
    y: 159,
    width: 23,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_7089_144",
    x: 809,
    y: 155,
    width: 36,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_7089_144",
    x: 813,
    y: 151,
    width: 32,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_7089_144",
    x: 811,
    y: 150,
    width: 24,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_7089_144",
    x: 792,
    y: 138,
    width: 48,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "effect1_foregroundBlur_7089_144"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1492,
    height: 230,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(1161 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(936 102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(1091 102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(1161 191)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(301 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(523 102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "matrix(-1 0 0 1 400 102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_7089_144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "matrix(-1 0 0 1 330 191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGinasteeAttributes);
export default __webpack_public_path__ + "static/media/ginastee-attributes.7ab1a1beb831438a4bea70e7ca3f2bda.svg";
export { ForwardRef as ReactComponent };